import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "../../../../reducer";
import { postOrder } from "../../../../api/order.api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

type ModalProps = {
  open: boolean;
  onClose: () => void;
};
export const OrderSummaryBar: FC<ModalProps> = ({ open, onClose }) => {
  const user = useSelector((state: State) => state.user);
  const order = useSelector((state: State) => state.order);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  if (!open) return null;

  const handlePlaceOrder = async () => {
    setIsLoading(true);
    postOrder({
      menu_id: order.menu_id,
      type: order.type,
      sweetness: 0,
      remark: order.remark,
      tumblerImage: "bar",
    })
      .then(async (result) => {
        if (result.status === "ordered") {
          try {
            notify();
            if (result.breakNotice) {
              toast.warn(result.breakNotice, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 5000,
              });
            }
            await new Promise((resolve) => setTimeout(resolve, 2000));
            if (user.role === "user") {
              navigate("/statusOrder", { replace: true });
            } else if (user.role === "admin") {
              navigate("/statusOrder-admin", { replace: true });
            }
          } catch (error) {
            console.error(error);
          } finally {
            setIsLoading(false); 
          }
        }
      })
      .catch(async (error) => {
        try {
          notifyCancel();
          await new Promise((resolve) => setTimeout(resolve, 2000));
          if (user.role === "user") {
            navigate("/menubar", { replace: true });
          } else if (user.role === "admin") {
            navigate("/menubar-admin", { replace: true });
          }
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false); 
        }
      });
  };

  const notify = () => {
    toast(
      <div className="ml-3 text-sm font-normal">
        <div className="my-3">
          <div className="flex">
            <svg
              className="my-1 mx-1"
              width="18"
              height="22"
              viewBox="0 0 18 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2.5H10.82C10.4 1.34 9.3 0.5 8 0.5C6.7 0.5 5.6 1.34 5.18 2.5H2C0.9 2.5 0 3.4 0 4.5V19.5C0 20.6 0.9 21.5 2 21.5H8.11C7.52 20.93 7.04 20.25 6.69 19.5H2V4.5H4V5.5C4 6.6 4.9 7.5 6 7.5H10C11.1 7.5 12 6.6 12 5.5V4.5H14V9.58C14.71 9.68 15.38 9.89 16 10.18V4.5C16 3.4 15.1 2.5 14 2.5ZM8 4.5C7.45 4.5 7 4.05 7 3.5C7 2.95 7.45 2.5 8 2.5C8.55 2.5 9 2.95 9 3.5C9 4.05 8.55 4.5 8 4.5ZM13 11.5C10.24 11.5 8 13.74 8 16.5C8 19.26 10.24 21.5 13 21.5C15.76 21.5 18 19.26 18 16.5C18 13.74 15.76 11.5 13 11.5ZM14.29 18.5L12.64 16.85C12.55 16.76 12.49 16.63 12.49 16.5V14.01C12.49 13.73 12.71 13.51 12.99 13.51C13.27 13.51 13.49 13.73 13.49 14.01V16.3L14.99 17.8C15.19 18 15.19 18.31 14.99 18.51C14.8 18.7 14.49 18.7 14.29 18.5Z"
                fill="#2BA666"
              />
            </svg>
            <div className="mx-1 my-1 text-sm font-semibold text-primary-onligth font-nunito fontSize-14">
              Order Placed Succesfully!
            </div>
          </div>

          <div className="ml-[30px] text-secondary-S700 font-normal font-nunito fontSize-12">
            You can check your order status at My Order
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={() => {
              if (user.role === "user") {
                navigate("/statusOrder", { replace: true });
              } else if (user.role === "admin") {
                navigate("/statusOrder-admin", { replace: true });
              }
            }}
            className="inline-flex p-2 font-nunito fontSize-12 font-medium text-center text-secondary-S600 bg-netural-N40 rounded-lg"
          >
            Go to My Order
          </button>
        </div>
      </div>,

      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
      }
    );
  };

  const notifyCancel = () => {
    toast(
      <div className="ml-3 text-sm font-normal">
        <div className="my-3">
          <div className="flex">
            <svg
              className="my-1 mx-1"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 11C9.45 11 9 10.55 9 10V6C9 5.45 9.45 5 10 5C10.55 5 11 5.45 11 6V10C11 10.55 10.55 11 10 11ZM11 15H9V13H11V15Z"
                fill="#DC3545"
              />
            </svg>

            <div className="mx-1 my-1 text-sm font-semibold text-primary-onligth font-nunito fontSize-14">
              Order failed!
            </div>
          </div>

          <div className="ml-[30px] text-secondary-S700 font-normal font-nunito fontSize-12">
            Seems like barista has just set this menu to inactive, please order
            another menu
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={() => {
              if (user.role === "user") {
                navigate("/menubar", { replace: true });
              } else if (user.role === "admin") {
                navigate("/menubar-admin", { replace: true });
              }
            }}
            className="inline-flex p-2 font-nunito fontSize-12 font-medium text-center text-secondary-S600 bg-netural-N40 rounded-lg"
          >
            OK, nvm
          </button>
        </div>
      </div>,

      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
      }
    );
  };

  return (
    <>
      <div className="font-nunito justify-center h-screen  items-center inset-0 z-50 fixed  overflow-y-auto">
        <div className="relative w-screen">
          {/*content*/}
          <div className="border-0 rounded-lg h-screen shadow-lg relative flex flex-col bg-white">
            {/*header*/}
            <div className="flex items-center py-[6px]">
              <button className="flex justify-start m-3" onClick={onClose}>
                <svg
                  width="10"
                  height="14"
                  viewBox="0 0 10 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.7499 0.38125C8.2624 -0.10625 7.4749 -0.10625 6.9874 0.38125L1.2499 6.11875C0.762402 6.60625 0.762402 7.39375 1.2499 7.88125L6.9874 13.6187C7.4749 14.1062 8.2624 14.1062 8.7499 13.6187C9.2374 13.1312 9.2374 12.3437 8.7499 11.8562L3.8999 6.99375L8.7499 2.14375C9.2374 1.65625 9.2249 0.85625 8.7499 0.38125Z"
                    fill="black"
                  />
                </svg>
              </button>

              <div className="pr-32 font-semibold text-18 text-primary-onligth text-center mx-auto">
                Order Summary
              </div>
            </div>
            <hr className="h-px"></hr>
            {/*body*/}
            <div className="relative mx-20 flex-auto">
              <div>
                <div>
                  <table>
                    <tr>
                      <td
                        className="text-14 font-semibold text-primary-onligth"
                        style={{ paddingRight: "36px", paddingTop: "15px" }}
                      >
                        Name
                      </td>
                      <td
                        className="text-14"
                        style={{ paddingTop: "16px", color: "#525252", wordBreak: "break-word"  }}
                      >
                        {order.menu_name}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="text-14 font-semibold text-primary-onligth"
                        style={{ paddingRight: "36px", paddingTop: "15px" }}
                      >
                        Size
                      </td>
                      <td
                        className="text-14"
                        style={{ paddingTop: "16px", color: "#525252" }}
                      >
                        {order.type}
                      </td>
                    </tr>
                  </table>
                </div>
                <div className="pt-16">
                  <table>
                    <tr>
                      <td className="text-14 font-semibold text-primary-onligth">
                        Description
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="text-14 pb-8"
                        style={{ paddingTop: "5px", color: "#525252",wordBreak: "break-word" }}
                      >
                        {order.tumblerImage}
                      </td>
                    </tr>
                  </table>
                  <hr className="h-[1px] bg-gray-200 border-0 "></hr>
                </div>
                <div className="py-8">
                  <table>
                    <tr>
                      <td className="text-14 font-semibold text-primary-onligth">
                        Additional Request
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="text-14"
                        style={{ paddingTop: "5px", color: "#525252", wordBreak: "break-word" }}
                      >
                        {order.remark}
                      </td>
                    </tr>
                  </table>
                  <hr className="h-[1px] bg-gray-200 border-0 "></hr>
                </div>
              </div>
            </div>

            {/*footer*/}
            <footer>
              <div className="flex justify-between gap-2 mx-20 mb-[64px]">
                <button
                  className="w-full text-16 h-48 font-semibold bg-netural-N40 text-secondary-S600  items-center  rounded-lg"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Edit
                </button>
                <button
                  className="w-full h-48 text-16 text-white items-center bg-[#F86903] rounded-lg"
                  onClick={() => {
                    handlePlaceOrder();
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? "Placing order..." : "Place order"}
                </button>
              </div>
            </footer>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
